import { NsPanel } from 'components/common/ns-panel/NsPanel';

export const testId = 'maintenancePageTestId';

export const Maintenance = () => {
  return (
    <>
      <ns-header hide-links />
      <main id="#content">
        <NsPanel testId={testId}>
          <ns-content>
            <h1>Please come back later</h1>
            <p>
              Unfortunately, we&apos;re having technical problems at the moment.
              Please try again later.
            </p>
            <p>
              Thank you for your patience, We&apos;re sorry for the
              inconvenience this might cause.
            </p>
          </ns-content>
        </NsPanel>
      </main>
      <nsx-footer />
    </>
  );
};
